module.exports = __webpack_public_path__ + "static/chromatic_orb-a9f19770fedb9f7d0677d0ac84e55c70.jpg";